unit Foto;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, TerminalForm,
  Vcl.Controls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids,
  WEBLib.Buttons, WEBLib.CDS, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCWebBrowser,
  VCL.TMSFNCCustomWEBControl, VCL.TMSFNCCustomWEBComponent, VCL.TMSFNCWXOCR, WEBLib.Devices, VCL.TMSFNCWXOCRHelper,
  XData.Web.Request,
  XData.Web.Response;

type
  TfrmFoto = class(TTerminalForm)
    btnOK: TButton;
    ocrReg: TTMSFNCWXOCR;
    Camera: TCamera;
    btnClose: TButton;
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnOKClick(Sender: TObject);
    procedure ocrRegFinishOCR(Sender: TObject; Result: TTMSFNCWXOCRResult);
    procedure FormCreate(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure CameraBeforeStart(Sender: TObject; var AConstraints: TJSObjectRecord);
  private
    FResult: string;
    { Private declarations }
    procedure ApplyTheme(Dark: boolean); reintroduce;
  public
    { Public declarations }
    property Res: string read FResult;
  protected procedure LoadDFMValues; override; end;

  TLoadedProc = reference to procedure;

var
  frmFoto: TfrmFoto;

implementation

{$R *.dfm}

uses Main, Client.Core, Auth.Service, Client.Constants, App.Types;

procedure TfrmFoto.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Log('Freeing frame');
  Action := caFree;
end;

procedure TfrmFoto.btnCloseClick(Sender: TObject);
begin
  inherited;
  frmMain.ShowCheck('');
end;

procedure TfrmFoto.btnOKClick(Sender: TObject);
var imgBase64: string;
begin
  inherited;
  // dobi sliko
  imgBase64 := Camera.SnapShotAsBase64;
  Camera.Pause;

  Log('Base64: '+imgBase64);

  // Proži OCR
(*  MarinaioService.Login(edtUser.Text, edtPass.Text,
      @LoginSuccess,
      @LoginError
    );*)

  Log('Result='+FResult);
end;

procedure TfrmFoto.CameraBeforeStart(Sender: TObject; var AConstraints: TJSObjectRecord);
begin
  inherited;
  AConstraints.jsobject.Properties['width'] := new(['ideal', 1920]);
  AConstraints.jsobject.Properties['height'] := new(['ideal', 1080]);
end;

procedure TfrmFoto.FormCreate(Sender: TObject);
begin
  inherited;
//  btnClose.Left := frmMain.Width - btnClose.Width - 20;
  Log('Starting camera...');
  Camera.Start;
end;

procedure TfrmFoto.ocrRegFinishOCR(Sender: TObject; Result: TTMSFNCWXOCRResult);
begin
  inherited;
  Log('Result confidence: ' + FloatToStr(Result.Confidence));
  FResult := Result.Text;

  Log('Result: '+FResult);

  if FResult<>'' then
    frmMain.ShowCheck(FResult);
end;

procedure TfrmFoto.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmFoto.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Camera := TCamera.Create(Self);
  btnOK := TButton.Create(Self);
  ocrReg := TTMSFNCWXOCR.Create(Self);
  btnClose := TButton.Create(Self);

  Camera.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  ocrReg.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  try
    Color := clBtnFace;
    Font.Height := -21;
    SetEvent(Self, 'OnCreate', 'FormCreate');
    Camera.SetParentComponent(Self);
    Camera.Name := 'Camera';
    Camera.Left := 0;
    Camera.Top := 0;
    Camera.Width := 660;
    Camera.Height := 815;
    Camera.Align := alClient;
    Camera.CameraType := ctRear;
    SetEvent(Camera, Self, 'OnBeforeStart', 'CameraBeforeStart');
    SetEvent(Camera, Self, 'OnClick', 'btnOKClick');
    btnOK.SetParentComponent(Self);
    btnOK.Name := 'btnOK';
    btnOK.AlignWithMargins := True;
    btnOK.Left := 272;
    btnOK.Top := 672;
    btnOK.Width := 116;
    btnOK.Height := 108;
    btnOK.Margins.Left := 10;
    btnOK.Margins.Right := 10;
    btnOK.Anchors := [akBottom];
    btnOK.Caption := '<i class="material-icons" style="font-size:40px;">camera</i>';
    btnOK.Center.Horizontal := True;
    btnOK.ChildOrder := 1;
    btnOK.ElementClassName := 'btn btn-danger btn-circle btn-lg';
    btnOK.ElementFont := efCSS;
    btnOK.HeightPercent := 100.000000000000000000;
    btnOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    ocrReg.SetParentComponent(Self);
    ocrReg.Name := 'ocrReg';
    ocrReg.Left := 24;
    ocrReg.Top := 64;
    ocrReg.Width := 26;
    ocrReg.Height := 26;
    ocrReg.ParentDoubleBuffered := False;
    ocrReg.DoubleBuffered := True;
    ocrReg.TabOrder := 0;
    ocrReg.Visible := True;
    ocrReg.Language := 'eng';
    SetEvent(ocrReg, Self, 'OnFinishOCR', 'ocrRegFinishOCR');
    btnClose.SetParentComponent(Self);
    btnClose.Name := 'btnClose';
    btnClose.AlignWithMargins := True;
    btnClose.Left := 0;
    btnClose.Top := 8;
    btnClose.Width := 62;
    btnClose.Height := 57;
    btnClose.Margins.Left := 10;
    btnClose.Margins.Right := 10;
    btnClose.Caption := '<i class="material-icons" style="font-size:40px;">close</i>';
    btnClose.ChildOrder := 1;
    btnClose.ElementClassName := 'btn btn-primary btn-circle btn-lg';
    btnClose.ElementFont := efCSS;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
  finally
    Camera.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    ocrReg.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
  end;
end;

end.
